import React, { useState, useEffect, useCallback } from "react";
import {
  Box,
  Button,
  Container,
  TextField,
  Typography,
  Stack,
  Paper,
  CircularProgress,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { ENDPOINT } from "../../../endpoints/endpoints";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const HighlightCreate = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: "",
    category:"",
    video_url:""
  });

  const [loading, setLoading] = useState(false);
  const [image, setImage] = useState(null);
  const [preview, setPreview] = useState(null);
  const [dragActive, setDragActive] = useState(false);

  const [categorys, setcategorys] = useState([]);
  const [categorySearch, setcategorySearch] = useState("");
  const [filteredcategorys,setfilteredcategory] = useState([]);

  // 🔹 Token Checking
  useEffect(() => {
    const token = localStorage.getItem("accessToken");
    if (!token) {
      toast.warning("Please log in to continue");
      navigate("/login");
    }else{
      fetchAllCategory();
    }
  }, [navigate]);

  // 🔹 Handle Text Change
  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const fetchAllCategory = async () => {
    const token = localStorage.getItem("accessToken");
      try {
        let url = ENDPOINT.HIGHLIGHTCATEGORY_LIST;
        let allResults = [];
  
        while (url) {
          const res = await axios.get(url, {
            headers: { Authorization: `Bearer ${token}` },
          });
  
          allResults = [...allResults, ...res.data.results];
          url = res.data.next; // load next pages
        }
  
        setcategorys(allResults);
        setfilteredcategory(allResults)
      } catch (error) {
        console.error("Error loading category list:", error);
        toast.error("Failed to load categorys");
      }
    };
  
    useEffect(()=>{
    let filteredcategory = categorys.filter((l) =>
      l.name.toLowerCase().includes(categorySearch.toLowerCase())
    );
    setfilteredcategory(filteredcategory)
    },[categorySearch])


      const handleFile = (file) => {
        if (file && file.type.startsWith("image/")) {
          setImage(file);
          setPreview(URL.createObjectURL(file));
        } else {
          toast.error("Please upload a valid image file!");
        }
      };
    
      const handleImageChange = (e) => handleFile(e.target.files[0]);
    
      const handleDragOver = (e) => {
        e.preventDefault();
        setDragActive(true);
      };
    
      const handleDragLeave = (e) => {
        e.preventDefault();
        setDragActive(false);
      };
    
      const handleDrop = (e) => {
        e.preventDefault();
        setDragActive(false);
        handleFile(e.dataTransfer.files[0]);
      };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const token = localStorage.getItem("accessToken");
      if (!token) {
        toast.error("You must log in first!");
        navigate("/login");
        return;
      }

      const data = new FormData();
      Object.keys(formData).forEach((key) => {
        data.append(key, formData[key]);
      });

      if (image) data.append("image", image);

      const response = await axios.post(ENDPOINT.HIGHLIGHT_CREATE, data, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });

      const msg = response.data.message || "Unknown response";
      if (response.data) {
        toast.success(msg);
        setTimeout(() => navigate("/highlight/list", { state: { toastMessage: msg } }), 1200);
      } else {
        toast.error(msg);
      }
    } catch (err) {
      console.error("Error creating highlight:", err);
      const backendMsg =
        err.response?.data?.message ||
        err.response?.data?.detail ||
        "Something went wrong.";
      toast.error(backendMsg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="md" sx={{ mt: 5, mb: 5 }}>
      <ToastContainer position="top-right" autoClose={3000} />

      <Paper elevation={3} sx={{ p: 4, borderRadius: 3 }}>
        <Typography variant="h5" fontWeight={600} mb={3}>
          🖼 Create New Highlight  
        </Typography>

        <form onSubmit={handleSubmit} encType="multipart/form-data">
          <Stack spacing={2}>
            {/* English Title */}
            <TextField
              label="Name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              fullWidth
              required
            />

              <FormControl fullWidth>
                <InputLabel id="category-label">category</InputLabel>
  
                <Select
                  labelId="category-label"
                  label="category"
                  name="category_id"
                  value={formData.category_id}
                  onChange={handleChange}
                  required
                  MenuProps={{ PaperProps: { style: { maxHeight: 350 } } }}
                >
                  {/* Search Box */}
                  <MenuItem disableRipple>
                    <TextField
                      fullWidth
                      placeholder="Search category..."
                      size="small"
                      value={categorySearch}
                      onChange={(e) => setcategorySearch(e.target.value)}
                      onClick={(e) => e.stopPropagation()}
                      onKeyDown={(e) => e.stopPropagation()} 
                    />
                  </MenuItem>
  
                  <MenuItem disabled>
                    <Typography variant="caption" color="text.secondary">
                      {filteredcategorys.length} results
                    </Typography>
                  </MenuItem>
  
                  {filteredcategorys.map((c) => (
                    <MenuItem key={c.id} value={c.id}>
                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        {c.name}
                      </Box>
                    </MenuItem>
                  ))}
  
                  {filteredcategorys.length === 0 && (
                    <MenuItem disabled>No results found</MenuItem>
                  )}
                </Select>
              </FormControl>
  
              {/* Image Upload */}
              <Box
                onDragOver={handleDragOver}
                onDragLeave={handleDragLeave}
                onDrop={handleDrop}
                sx={{
                  border: dragActive ? "2px dashed #1976d2" : "2px dashed #ccc",
                  borderRadius: 2,
                  p: 3,
                  textAlign: "center",
                  backgroundColor: dragActive ? "#f0f7ff" : "#fafafa",
                  cursor: "pointer",
                  transition: "0.2s",
                }}
                onClick={() => document.getElementById("fileInput").click()}
              >
                {preview ? (
                  <Box>
                    <Box
                      component="img"
                      src={preview}
                      alt="Preview"
                      sx={{
                        width: 200,
                        height: 200,
                        objectFit: "cover",
                        borderRadius: 2,
                        border: "1px solid #ddd",
                      }}
                    />
                    <Typography variant="body2" mt={1}>
                      Click or drop a new image to replace
                    </Typography>
                  </Box>
                ) : (
                  <Typography variant="body1" color="text.secondary">
                    Drag & drop image here, or click to select
                  </Typography>
                )}
  
                <input
                  id="fileInput"
                  type="file"
                  hidden
                  accept="image/*"
                  onChange={handleImageChange}
                />
              </Box>

              <TextField
              label="Video URL"
              name="video_url"
              value={formData.video_url}
              onChange={handleChange}
              fullWidth
              required
            />

            {/* Submit Button */}
            <Box textAlign="right" mt={2}>
              <Button
                type="submit"
                variant="contained"
                color="success"
                disabled={loading}
                sx={{ px: 4, textTransform: "none" }}
              >
                {loading ? <CircularProgress size={24} color="inherit" /> : "Create Highlight"}
              </Button>
            </Box>
          </Stack>
        </form>
      </Paper>
    </Container>
  );
};

export default HighlightCreate;
